// Mirrors signatureMatchesName in server/src/utils/signature.js.
//
// The server is the authority - this is here so somebody finds out while typing
// rather than after submitting. The two implementations have to agree, so any
// change to one belongs in both, and the server-side rules have a test suite in
// server/src/utils/__tests__/signature.test.js.

export function nameTokens(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    // Apostrophes are removed rather than treated as separators, so O'Brien
    // stays one token and matches somebody typing "OBrien". Hyphens and the
    // rest still separate, so "O'Brien-Smith" is ["obrien", "smith"].
    .replace(/['\u2018\u2019`]/g, '')
    .replace(/[^a-z\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean);
}

/**
 * Must START with the first name and END with the last name.
 *
 * Checking only that the name appeared somewhere accepted "Test Admin ghjghj" -
 * the name was present, so anything appended came along with it. Bounding both
 * ends still allows a middle name or an initial, which people genuinely sign
 * with, while leaving nowhere to put anything else.
 *
 * No name on the profile means nothing to check against, so it does not block.
 */
export function matchesName(signature, user) {
  const first = nameTokens(user?.firstName ?? user?.first_name);
  const last = nameTokens(user?.lastName ?? user?.last_name);
  if (first.length === 0 || last.length === 0) return true;

  const signed = nameTokens(signature);
  if (signed.length < first.length + last.length) return false;

  const startsWithFirst = first.every((token, i) => signed[i] === token);
  const offset = signed.length - last.length;
  const endsWithLast = last.every((token, i) => signed[offset + i] === token);

  return startsWithFirst && endsWithLast;
}
